import React from 'react'
import { HomeOutlined } from '@ant-design/icons'
import { Button, Tooltip, Flex } from 'antd'
import { useHistory } from 'react-router-dom'
import { useIntl } from 'react-intl'

export const HomeButton = ({ disabled = false }) => {
  const history = useHistory()
  const intl = useIntl()

  return (
    <Flex gap="small" align="center">
      <Tooltip
        title={intl.formatMessage(
          { id: 'home.buttonTooltipText' },
          { defaultMessage: 'Go to Home' },
        )}
      >
        <Button
          color="primary"
          size="large"
          icon={<HomeOutlined />}
          onClick={() => {
            history.push('/')
          }}
          disabled={disabled}
        />
      </Tooltip>
    </Flex>
  )
}
